import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ff9400',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#c53929'
            },
            dark: {
                primary: '#ff9400',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#c53929'
            }
        }
    }
});
